export const ASPAEC_PRESCRIBER_IDS = [97, 3418, 10462, 1734]
